var NotificationCenterClickType;
(function (NotificationCenterClickType) {
    NotificationCenterClickType["DELETE"] = "Delete";
    NotificationCenterClickType["MARK_ALL_AS_READ"] = "MarkAllAsRead";
    NotificationCenterClickType["MARK_AS_READ"] = "MarkAsRead";
    NotificationCenterClickType["MARK_AS_UNREAD"] = "MarkAsUnread";
    NotificationCenterClickType["NOTIFICATION_CLICK"] = "NotificationClick";
})(NotificationCenterClickType || (NotificationCenterClickType = {}));
export { NotificationCenterClickType, };
//# sourceMappingURL=notification-center-constants.js.map